export default class ObjectHeader {
    constructor(elem) {
        this.elements = {
            holder: elem,
            siteWrapper: document.querySelector(".js-site-wrapper")
        };

        this.elements.header = this.elements.holder.querySelector(
            ".js-object-header-element"
        );
        this.elements.placeholder = this.elements.holder.querySelector(
            ".js-object-header-placeholder"
        );

        this.siteWrapperBottomPadding = 0;

        if (this.elements.siteWrapper) {
            this.siteWrapperBottomPadding = parseInt(
                getComputedStyle(
                    this.elements.siteWrapper,
                    null
                ).getPropertyValue("padding-bottom")
            );
        }

        if (this.elements.header) {
            this.headerHeight = this.elements.header.offsetHeight;
            this.headerClientRect = this.elements.header.getBoundingClientRect();
            this.headerTopOffset = this.headerClientRect.top + window.scrollY; // (relative to the document)

            this._setDOMReferences();
        }
    }

    _setDOMReferences() {
        const self = this;

        let last_known_scroll_position = 0;
        let ticking = false;
        let isSticky = false;

        function onScroll(scroll_pos) {
            if (scroll_pos > self.headerHeight + self.headerTopOffset) {
                if (!isSticky) {
                    self.doSticky();
                    isSticky = true;
                }
            } else {
                if (isSticky) {
                    self.undoSticky();
                    isSticky = false;
                }
            }
        }

        window.addEventListener("scroll", function(e) {
            last_known_scroll_position = window.scrollY;

            if (!ticking) {
                window.requestAnimationFrame(function() {
                    onScroll(last_known_scroll_position);
                    ticking = false;
                });

                ticking = true;
            }
        });
    }

    doSticky() {
        this.elements.header.classList.add("is--sticky");
        this.elements.placeholder.style.height = this.headerHeight / 10 + "rem";

        if (this.elements.siteWrapper) {
            const stickyHeaderHeight = this.elements.header.offsetHeight; // sticky element height
            this.elements.siteWrapper.style.paddingBottom =
                (stickyHeaderHeight + this.siteWrapperBottomPadding) / 10 +
                "rem";
        }
    }

    undoSticky() {
        this.elements.header.classList.remove("is--sticky");
        this.elements.placeholder.style.height = "0rem";
        this.elements.siteWrapper.style.paddingBottom =
            this.siteWrapperBottomPadding / 10 + "rem";
    }
}
